module.exports = __webpack_public_path__ + "img/PD1504781281899184128.158b39a7.png";